import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { ITopicAttachment } from "Data/interfaces/Activities/IDragAndDropDataFormat";
import { getIsLoadingRenameAttachment } from "Store/Activities/Activities.selector";
import { ActivitiesActions } from "Store/Activities/Activities.actions";
import Modal from "Components/UI/Modal";
import Button from "Components/UI/Button";
import Ellipsis from "Components/UI/Ellipsis";
import FieldControled from "Components/UI/FieldControled";
import schema from "./renameAttachment.schema";
import { Buttons, Wrapper } from "./styles";

interface IRenameAttachment {
  visible: boolean;
  attachment: ITopicAttachment;
  onCancel: () => void;
}

const RenameAttachment: FC<IRenameAttachment> = ({
  visible,
  attachment,
  onCancel,
}) => {
  const dispatch = useDispatch();
  const loading = useSelector(getIsLoadingRenameAttachment);
  const [isSubmit, setIsSubmit] = useState(false);

  const {
    control,
    trigger,
    handleSubmit,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      newName: attachment.File.Name,
    },
  })

  const getExtension = (filename: string): string => {
    const lastDotIndex = filename.lastIndexOf('.');
    return lastDotIndex !== -1 ? filename.substring(lastDotIndex) : '';
  };

  const submit = (values: any) => {
    const originalExtension = getExtension(attachment.File.Name);
    let newName = values.newName.trim();
    
    if (originalExtension && !newName.toLowerCase().endsWith(originalExtension.toLowerCase())) {
      newName = `${newName}${originalExtension}`;
    }

    dispatch(ActivitiesActions.renameAttachment({
      guid: attachment.TopicFk,
      topicAttachmentId: attachment.TopicAttachmentId,
      newName: newName,
    }));
    setIsSubmit(true);
  };

  useEffect(() => {
    if (!loading && isSubmit) {
      setIsSubmit(false);
      onCancel();
    }
  }, [loading, isSubmit]);

  const footerConfirmButtons = (
    <Buttons>
      <Button
        onClick={onCancel}
        type="text"
        className="buttonCancel"
      >
        Cancelar
      </Button>
      <Button
        type="primary"
        className="buttonSubmit"
        loading={loading}
        onClick={handleSubmit(submit)}
      >
        Salvar
      </Button>
    </Buttons>
  );

  return (
    <Modal
      visible={visible}
      title={(
        <Ellipsis
          phrase={`Renomear "${attachment.File.Name}"`}
          maxLength={75}
        />
      )}
      footerButtons={footerConfirmButtons}
      footerActive={false}
      width={400}
      customClassName
      newHeader
      onCancel={onCancel}
    >
      <Wrapper>
        <form className="form">
          <FieldControled
            label=""
            name="newName"
            className="inputNewName"
            control={control}
            trigger={trigger}
          />
        </form>
      </Wrapper>
    </Modal>
  )
}

export default RenameAttachment;
